import React from "react";
import styles from "./portfolio.module.css";
import { PROCESSED_BOOKS } from "../../../data/processed-books";
import { Image } from "antd";
import { useHydrated } from "../../../hooks/useHydrated";

// Правильные импорты для Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

// Обязательные базовые стили Swiper
import "swiper/css";

export const SectionPortfolio = () => {
  const hydrated = useHydrated();
  return (
    <section className={styles.sectionPortfolioContainer} id="portfolio">
      <div className={styles.sectionPortfolioWrap}>
        <div className={styles.sectionPortfolioTitleContainer}>
          <h2 className={styles.sectionPortfolioTitle}>Разобранное</h2>
          <p className={styles.sectionPortfolioSubtitle}>
            Книги, которые мы уже разобрали на встречах клуба
          </p>
        </div>

        {/* Контейнер для списка книг (в одну колонку) */}
        <div className={styles.booksGrid}>
          {PROCESSED_BOOKS.map((book) => (
            <div key={book.id} className={styles.bookItemRow}>
              <h3 className={styles.bookTitle}>
                <a href={`/books#${book.id}`} className={styles.bookTitleLink}>
                  {book.title}
                </a>
              </h3>

              <div className={styles.galleryWrapper}>
                {/* Ant Design PreviewGroup собирает все картинки книги в одну галерею при просмотре */}
                <Image.PreviewGroup items={book.images} preview={{ toolbarRender: () => null }}>
                  {hydrated ? (
                  <Swiper
                    modules={[Autoplay]}
                    spaceBetween={10}
                    slidesPerView={1}
                    loop={book.images.length > 1}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    className={styles.mySwiper}
                  >
                    {book.images.map((image, index) => (
                      <SwiperSlide key={`${book.id}-${index}`}>
                        <div className={styles.imageContainer}>
                          {/* 1. Эффект размытого фона сзади */}
                          <img
                            src={image}
                            alt=""
                            className={styles.backgroundImageBlur}
                          />

                          {/* 2. Основная картинка по центру (Ant Design) */}
                          <div className={styles.mainImageWrapper}>
                            <Image
                              alt={`${book.title} - фото ${index + 1}`}
                              src={image}
                              className={styles.mainImage}
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}

                  </Swiper>
                  ) : (
                    <div className={styles.imageContainer}>
                      <img
                        src={book.images[0]}
                        alt=""
                        className={styles.backgroundImageBlur}
                      />
                      <div className={styles.mainImageWrapper}>
                        <Image
                          alt={`${book.title} - фото 1`}
                          src={book.images[0]}
                          className={styles.mainImage}
                        />
                      </div>
                    </div>
                  )}
                </Image.PreviewGroup>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
